import React from 'react';
import './UIProperty.scss';
import { safeToLowerCase } from '../../../utils/stringUtils';

const baseClass = 'UIProperty';

interface UIPropertyProps {
  name: string;
  type?: 'residential' | 'commercial' | 'mixed' | 'industrial' | null;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  className?: string;
}

const UIProperty: React.FC<UIPropertyProps> = ({
  name,
  type,
  onClick,
  className = '',
}) => {
  const getBadgeClass = (): string => {
    const baseBadgeClass = 'UIProperty__badge';
    if (!type) {
      return `${baseBadgeClass} ${baseBadgeClass}--no-units`;
    }

    const modifiers: { [key: string]: string } = {
      commercial: `${baseBadgeClass}--commercial`,
      mixed: `${baseBadgeClass}--mixed`,
      industrial: `${baseBadgeClass}--industrial`,
    };

    const lowercasedType = safeToLowerCase(type);
    const modifier = modifiers[lowercasedType];

    return modifier ? `${baseBadgeClass} ${modifier}` : baseBadgeClass;
  };

  const getContainerClass = (): string => {
    return [baseClass, className, onClick && `${baseClass}--clickable`]
      .filter(Boolean)
      .join(' ');
  };

  return (
    <div className={getContainerClass()} onClick={onClick}>
      <div className={`${baseClass}__name`}>{name || 'Unknown Property'}</div>
      <div className={getBadgeClass()}>{type || 'No units'}</div>
    </div>
  );
};

export default UIProperty;
